import { render, staticRenderFns } from "./BasePrimaryButton.vue?vue&type=template&id=1295c6e2&scoped=true&"
import script from "./BasePrimaryButton.vue?vue&type=script&lang=js&"
export * from "./BasePrimaryButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1295c6e2",
  null
  
)

export default component.exports